import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,message, Space,Modal,Select,Radio,DatePicker,TimePicker,AutoComplete,InputNumber,Tag } from 'antd';
// import Icon,{EditOutlined  } from '@ant-design/icons';
// import './index.css';
import {api_turbotq_view, BASE} from '../../../api';
import { localStorageGet } from '../../../utils/global.js';

// const { TextArea } = Input;
const { Option } = Select;
const screenHeight = document.body.clientHeight;

const App =(props)=>{
    const {showModal, closeModal, rowInfo} = props;
    console.log('1111111111111111111111111111111111111-', rowInfo)
    const [pdfContent, setPdfContent] = useState('');

    const currentUserinfo = localStorageGet('UserInfo_k');

    useEffect(() => {
      // if(showModal){
      //   if(rowInfo.path)
      //     getPdf();
      // }else{
      //   setPdfContent("");
      // }
    }, [showModal, rowInfo]);


  // 获取PDF预览内容
  const getPdf = async ()=>{
    try {
      api_turbotq_view({path:rowInfo.path}).then((res) => {
        console.log('api_turbotq_view-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        setPdfContent(res.data);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }

  }
  
  return (
    <Modal 
        key="orderinfo"
        title={rowInfo.name+" "+rowInfo.type+"报告"}
        open={showModal}
        width={"90%"}
        bodyStyle={{maxHeight:screenHeight*0.8}}
        centered
        destroyOnClose={true}
        maskClosable={false}
        footer={[<Button  className="m-btn-white" onClick={closeModal}>
        关闭
        </Button>,
        ] }
        onCancel={closeModal}>
        <iframe src={BASE+"turbotq_view.php?debug=&path="+rowInfo.path+"&type="+rowInfo.type+"&token="+localStorage.getItem('token_k')} width="100%" height={screenHeight} frameBorder="0" ></iframe>
      </Modal>
  )
}
export default App
